// ✅ CONFIGURACIÓN DE GRUPOS DE MENÚ - REUTILIZANDO IMPORTS EXACTOS DEL ARCHIVO ORIGINAL
// Este archivo mapea los elementos del menú actual a la nueva estructura agrupada

import React from 'react';

// Iconos de los elementos del menú
// eslint-disable-next-line no-unused-vars
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import GroupWorkIcon from "@material-ui/icons/GroupWork";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import AccountTreeOutlinedIcon from "@material-ui/icons/AccountTreeOutlined";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import CodeRoundedIcon from "@material-ui/icons/CodeRounded";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import PeopleIcon from "@material-ui/icons/People";
import ListIcon from "@material-ui/icons/ListAlt";
import WatchLaterIcon from "@material-ui/icons/WatchLater";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import ForumIcon from "@material-ui/icons/Forum";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import CardMembershipIcon from '@material-ui/icons/CardMembership';
// import RotateRight from "@material-ui/icons/RotateRight"; // ✅ No utilizado por ahora
import LoyaltyRoundedIcon from '@material-ui/icons/LoyaltyRounded';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import { AllInclusive, AttachFile, DeviceHubOutlined, Schedule, Speed as SpeedIcon, Assessment as AssessmentIcon, AccountTree, Tune, Description as DescriptionIcon } from '@material-ui/icons';
// eslint-disable-next-line no-unused-vars

// ✅ FUNCIÓN UNIFICADA PARA RENDERIZAR ICONOS CON ESTILO CONSISTENTE
const renderIconUnified = (IconComponent) => {
  return (
    <IconComponent 
      style={{ 
        fontSize: '20px',
        color: 'inherit',
        transition: 'all 0.2s ease-in-out',
      }}
    />
  );
};

// ✅ FUNCIONES DE ICONOS (MANTENIDAS PARA COMPATIBILIDAD, PERO USAN ESTILO UNIFICADO)
const renderIconWhatsApp = renderIconUnified;
const renderIconDashboard = renderIconUnified;
const renderIconMensajes = renderIconUnified;
const renderIconConfiguracion = renderIconUnified;
const renderIconUtilidades = renderIconUnified;
const renderIconGruposWA = renderIconUnified;

// ✅ CONFIGURACIÓN DE GRUPOS DE MENÚ
export const menuGroupsConfig = {
  whatsapp: {
    id: 'whatsapp',
    titleKey: 'mainDrawer.groups.whatsapp',
    icon: '💬',
    renderIcon: renderIconWhatsApp,
    expanded: true, // ✅ Expandido por defecto
    items: [
      {
        name: 'Tickets',
        route: '/tickets',
        icon: WhatsAppIcon,
        translationKey: 'mainDrawer.listItems.tickets',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'Respuestas rápida',
        route: '/quick-messages',
        icon: FlashOnIcon,
        translationKey: 'mainDrawer.listItems.quickMessages',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'Kanban',
        route: '/kanban',
        icon: LoyaltyRoundedIcon,
        translationKey: 'mainDrawer.listItems.kanban',
        permission: 'drawer-service-items:view',
        conditional: 'showKanban'
      },
      {
        name: 'Contactos',
        route: '/contacts',
        icon: ContactPhoneOutlinedIcon,
        translationKey: 'mainDrawer.listItems.contacts',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'Agenda',
        route: '/schedules',
        icon: Schedule,
        translationKey: 'mainDrawer.listItems.schedules',
        permission: 'drawer-service-items:view',
        conditional: 'showSchedules'
      },
      {
        name: 'Etiquetas',
        route: '/tags',
        icon: LocalOfferIcon,
        translationKey: 'mainDrawer.listItems.tags',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'Lista de archivos',
        route: '/files',
        icon: AttachFile,
        translationKey: 'mainDrawer.listItems.files',
        permission: 'drawer-service-items:view'
      },
      {
        // Visible para TODOS los perfiles a propósito (doc 0380 H4): un agente
        // debe poder saber a qué equipo pertenece y quién lo supervisa.
        name: 'Mi equipo',
        route: '/my-team',
        icon: GroupWorkIcon,
        translationKey: 'mainDrawer.listItems.myTeam',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'Ayuda',
        route: '/helps',
        icon: HelpOutlineIcon,
        translationKey: 'mainDrawer.listItems.helps',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'API',
        route: '/messages-api',
        icon: CodeRoundedIcon,
        translationKey: 'mainDrawer.listItems.messagesAPI',
        permission: 'drawer-admin-items:view', // ✅ MANTENER: Solo admins pueden usar API
        conditional: 'showExternalApi'
      }
    ]
  },
  
  dashboard: {
    id: 'dashboard',
    titleKey: 'mainDrawer.groups.dashboard',
    icon: '📊',
    renderIcon: renderIconDashboard,
    expanded: false,
    route: null, // ✅ Sin ruta directa - solo submenús
    items: [
      {
        name: 'Métricas',
        route: '/',
        icon: DashboardOutlinedIcon,
        translationKey: 'mainDrawer.listItems.metrics',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Conexiones',
        route: '/dashboard/connections',
        icon: SyncAltIcon,
        translationKey: 'mainDrawer.listItems.connections',
        permission: 'drawer-admin-items:view'
      },
      // ✅ ELIMINADO: "Rendimiento CPU" - Ya no se necesita, reemplazado por "Rendimiento VPS"
      {
        name: 'WhatsApp',
        route: '/dashboard/whatsapp',
        icon: WhatsAppIcon,
        translationKey: 'mainDrawer.listItems.dashboardWhatsApp',
        permission: 'drawer-admin-items:view',
        conditional: 'user.super' // Solo super admin
      },
      {
        name: 'Rendimiento VPS',
        route: '/dashboard/vps-performance',
        icon: SpeedIcon,
        translationKey: 'mainDrawer.listItems.vpsPerformance',
        permission: 'drawer-admin-items:view',
        conditional: 'user.super' // Solo super admin
      }
    ]
  },
  
  gruposWA: {
    id: 'gruposWA',
    titleKey: 'mainDrawer.groups.gruposWA',
    icon: '👥',
    renderIcon: renderIconGruposWA,
    expanded: false,
    items: [
      {
        name: 'Lista de Grupos',
        route: '/groups-wa',
        icon: PeopleIcon,
        translationKey: 'mainDrawer.listItems.groupsWA',
        permission: 'drawer-admin-items:view' // ✅ Solo admins pueden acceder
      },
      {
        name: 'Campañas de Grupos',
        route: '/group-campaigns',
        icon: ListIcon,
        translationKey: 'mainDrawer.listItems.groupCampaigns',
        permission: 'drawer-admin-items:view' // ✅ Solo admins pueden acceder
      }
    ]
  },
  
  mensajes: {
    id: 'mensajes',
    titleKey: 'mainDrawer.groups.mensajes',
    icon: '📢',
    renderIcon: renderIconMensajes,
    expanded: false,
    items: [
      {
        name: 'Envío de mensajes',
        route: '/campaigns',
        icon: ListIcon,
        translationKey: 'mainDrawer.listItems.campaignsDispatch',
        permission: 'drawer-admin-items:view',
        conditional: 'showCampaigns'
      },
      {
        name: 'Campañas Meta',
        route: '/meta-campaigns',
        icon: DescriptionIcon,
        translationKey: 'mainDrawer.listItems.metaCampaigns',
        permission: 'drawer-admin-items:view',
        conditional: 'showCampaigns'
      },
      {
        name: 'Plantillas Meta',
        route: '/plantillas-meta',
        icon: DescriptionIcon,
        translationKey: 'mainDrawer.listItems.wabaTemplates',
        permission: 'drawer-admin-items:view',
        conditional: 'showCampaigns'
      },
      {
        name: 'Individual',
        route: '/scheduled-messages',
        icon: WatchLaterIcon,
        translationKey: 'mainDrawer.listItems.scheduledMessages',
        permission: 'drawer-admin-items:view',
        conditional: 'showCampaigns'
      },
      {
        name: 'Lista de contactos',
        route: '/contact-lists',
        icon: PeopleIcon,
        translationKey: 'mainDrawer.listItems.contactLists',
        permission: 'drawer-admin-items:view',
        conditional: 'showCampaigns'
      },
      {
        name: 'Informe de Envío',
        route: '/campaign-shipping-reports',
        icon: AssessmentIcon,
        translationKey: 'mainDrawer.listItems.campaignShippingReports',
        permission: 'drawer-admin-items:view',
        conditional: 'showCampaigns'
      },
      {
        name: 'Plantillas de Difusión',
        route: '/broadcast-templates',
        icon: DescriptionIcon,
        translationKey: 'mainDrawer.listItems.broadcastTemplates',
        permission: 'drawer-admin-items:view',
        conditional: 'showCampaigns'
      },
      // ❌ DEPRECADO: Configuración de intervalos ahora está integrada en el formulario de campañas
      // {
      //   name: 'Tiempos de envío',
      //   route: '/campaigns-config',
      //   icon: ListIcon,
      //   translationKey: 'hardcodedElements.configuracoes',
      //   permission: 'drawer-admin-items:view',
      //   conditional: 'showCampaigns'
      // }
    ]
  },
  
  configuracion: {
    id: 'configuracion',
    titleKey: 'mainDrawer.groups.configuracion',
    icon: '⚙️',
    renderIcon: renderIconConfiguracion,
    expanded: false,
    items: [
      {
        name: 'Conexiones',
        route: '/connections',
        icon: SyncAltIcon,
        translationKey: 'mainDrawer.listItems.connections',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Departamentos',
        route: '/queues',
        icon: AccountTreeOutlinedIcon,
        translationKey: 'mainDrawer.listItems.queues',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Agentes IA',
        route: '/prompts',
        icon: AllInclusive,
        translationKey: 'mainDrawer.listItems.prompts',
        permission: 'drawer-admin-items:view',
        conditional: 'showOpenAi'
      },
      {
        name: 'Subscripción',
        route: '/financeiro',
        icon: CardMembershipIcon,
        translationKey: 'mainDrawer.listItems.subscription',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Configuraciones',
        route: '/settings',
        icon: SettingsOutlinedIcon,
        translationKey: 'mainDrawer.listItems.settings',
        permission: 'drawer-admin-items:view'
      }
    ]
  },
  
  /**
   * ADMINISTRACIÓN — quién es quién y qué puede hacer.
   *
   * WHY grupo propio y no dentro de Configuración: allí convivían con
   * conexiones, plantillas y ajustes del producto, y no se encontraban. Estas
   * tres pantallas responden a una pregunta distinta —gobierno de personas, no
   * configuración del canal— y juntas se exploran solas.
   *
   * Acceso: `drawer-admin-items:view`, igual que Configuración. Lo tienen el
   * superadministrador y el administrador de empresa; un agente no ve el grupo.
   */
  administracion: {
    id: 'administracion',
    titleKey: 'mainDrawer.groups.administracion',
    icon: '🛡️',
    renderIcon: renderIconConfiguracion,
    expanded: false,
    items: [
      {
        name: 'Rol de usuario',
        route: '/users',
        icon: PeopleAltOutlinedIcon,
        translationKey: 'mainDrawer.listItems.userRoles',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Roles y permisos',
        route: '/roles',
        icon: VpnKeyIcon,
        translationKey: 'mainDrawer.listItems.rolesPermissions',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Subagrupaciones',
        route: '/user-groups',
        icon: GroupWorkIcon,
        translationKey: 'mainDrawer.listItems.userGroups',
        permission: 'drawer-admin-items:view',
        // Solo para empresas que trabajan por equipos (doc 0380 D7). Sin esto,
        // el cliente de un solo administrador ve una página que no necesita.
        conditional: 'teamsEnabled'
      }
    ]
  },

  flowbuilder: {
    id: 'flowbuilder',
    titleKey: 'mainDrawer.groups.flowbuilder',
    icon: '🔄',
    renderIcon: renderIconUtilidades,
    expanded: false,
    items: [
      {
        name: 'Lista de Flujos',
        route: '/flowbuilders',
        icon: AccountTree,
        translationKey: 'mainDrawer.listItems.flowbuilders',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Campañas de Flujo',
        route: '/flowcampaigns',
        icon: ListIcon,
        translationKey: 'mainDrawer.listItems.flowcampaigns',
        permission: 'drawer-admin-items:view'
      }
    ]
  },
  
  utilidades: {
    id: 'utilidades',
    titleKey: 'mainDrawer.groups.utilidades',
    icon: '🔧',
    renderIcon: renderIconUtilidades,
    expanded: false,
    items: [
      {
        name: 'Integraciones',
        route: '/queue-integration',
        icon: DeviceHubOutlined,
        translationKey: 'mainDrawer.listItems.queueIntegration',
        permission: 'drawer-admin-items:view',
        conditional: 'showIntegrations'
      },
      {
        name: 'Chat local',
        route: '/chats',
        icon: ForumIcon,
        translationKey: 'mainDrawer.listItems.localChat',
        permission: 'drawer-service-items:view',
        conditional: 'showInternalChat'
      },
      {
        name: 'Anuncios',
        route: '/announcements',
        icon: AnnouncementIcon,
        translationKey: 'mainDrawer.listItems.annoucements',
        permission: 'drawer-admin-items:view',
        conditional: 'user.superOrCompanyAdmin'
      }
    ]
  }
};

// ✅ FUNCIONES HELPER
export const getMenuGroupConfig = (groupId) => {
  return menuGroupsConfig[groupId] || null;
};

export const getAllMenuGroups = () => {
  return Object.values(menuGroupsConfig);
};

export const getMenuGroupItems = (groupId) => {
  const group = getMenuGroupConfig(groupId);
  return group ? group.items : [];
};